import { useState, useEffect } from "react";

function getWindowDimension() {
  const { innerWidth: width, innerHeight: height } = window;

  const isMobile = width < 768;
  const isDesktop = width >= 768;

  return {
    width,
    height,
    isMobile,
    isDesktop,
  };
}

export default function useWindowDimension() {
  const [windowDimension, setWindowDimension] = useState(getWindowDimension());

  useEffect(() => {
    function handleResize() {
      setWindowDimension(getWindowDimension());
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimension;
}
